import { useNotification } from "@/shared/feedback/notification";
import { useMutation } from "@apollo/client";
import { useTranslations } from "use-intl";
import { DELETE_DYNAMIC_ATTRIBUTE_GROUP } from "../api/delete-dynamic-attribute-group";
import { GET_ENTITY_ATTRIBUTES } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor/api/get-entity-attributes";

export function useRemoveDynamicAttributeGroup({
  afterSubmit,
}: {
  afterSubmit?: () => void;
}) {
  const notify = useNotification();
  const t = useTranslations("DeleteGroupButton");

  const [removeGroup] = useMutation(DELETE_DYNAMIC_ATTRIBUTE_GROUP, {
    refetchQueries: [GET_ENTITY_ATTRIBUTES],
  });

  const remove = async (id: string) => {
    const response = await removeGroup({
      variables: {
        id,
      },
    });

    if (response.data?.removeDynamicAttributeGroup) {
      afterSubmit?.();
      notify?.success({
        message: t("Group has been deleted"),
      });
    }
  };

  return {
    remove,
  };
}
